import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { LstStorePeriodResponse } from 'src/app/shared/models/lstStorePeriodResponse';
import { StorePeriod } from 'src/app/shared/models/StorePeriod';
import { Store } from 'src/app/shared/models/Store';
import * as FileSaver from 'file-saver';
import autoTable from 'jspdf-autotable'
import { LstStoreResponse } from 'src/app/shared/models/lstStoreResponse';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';

@Component({
  selector: 'app-stored-period-hdr',
  templateUrl: './stored-period-hdr.component.html',
  styleUrls: ['./stored-period-hdr.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class StoredPeriodHdrComponent implements OnInit {


  lstStore: Store[];
  currentPeriod: string;
  selectedCoord: Store;
  findCoordInput: number;
  lstStoreResp: LstStoreResponse;
  storeInfo: Store = {};


  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService,
    private filesService: TovpilFilesService,) {
    const navigation = this.router.getCurrentNavigation();
    const storeParent = navigation.extras.state as Store;
    if (storeParent) {
      this.selectedCoord = storeParent;
      this.findCoordInput = parseInt(storeParent.supStoreId);
      this.findCoord();
    }
  }

  ngOnInit(): void {
    this.getPeriodToday();
  }

  getPeriodToday() {
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth() + 1;
    let period = currentMonth < 7 ? 1 : 2;
    this.currentPeriod = currentYear + " - " + period;
  }

  findCoord() {
    let search = this.tovpilUtils.padLeft(this.findCoordInput.toString(), '0', 10);
    this.apiService.getListStore(search, null, null).then(
      lstStores => {
        this.lstStoreResp = lstStores;
        this.lstStore = this.lstStoreResp.lstStore;
      });

    this.apiService.getStoreById({ storeId: search }).then(
      store => {
        this.storeInfo = store;
      });
  }

  exportExcel() {
    if (this.lstStore === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.lstStore.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.lstStore.map((item) => ({
        "ID_HIJO": item.storeId || 'S/N',
        "NOMBRE": item.descri || 'S/N',
        "TIPO": item.type || 'S/N'
      }));


      this.filesService.tovpilExportXLSX(filteredJSON, 'listStoredPeriod_');

    }
  }



  exportPdf() {
    if (this.lstStore === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.lstStore.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.lstStore.map((item) => ({
        "ID_HIJO": item.storeId || 'S/N',
        "NOMBRE": item.descri || 'S/N',
        "TIPO": item.type || 'S/N'
      }));



      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listStoredPeriod_');

    }
  }



  redirectDetail(coord: Store) {
    coord.supStoreId = this.tovpilUtils.padLeft(this.findCoordInput.toString(), '0', 10);
    coord.shrNameZon = this.storeInfo.shrName;
    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(coord))
    }
    this.router.navigate(['catalog/periodStoreDtl'], navigationExtras);
  }

}
